<template>
  <VaSidebar :width="isMobile ? '100vw' : '280px'" :color="color" minimized-width="0">
    <VaAccordion v-model="value" multiple>
      <VaCollapse v-for="(item, index) in mainRoutes" :key="index">
        <template #header="">
          <VaSidebarItem
            :to="item.path"
            :active="routeHasActiveChild(item)"
            :active-color="activeColor"
            :text-color="textColor(item)"
            role="button"
            hover-opacity="0.10"
          >
            <VaSidebarItemContent class="py-3 pr-2 pl-4">
              <VaIcon
                v-if="item.icon"
                aria-hidden="true"
                :name="item.icon"
                size="20px"
                :color="iconColor(item)"
              />
              <VaSidebarItemTitle class="flex justify-between items-center leading-5 font-semibold">
                {{ item.name }}
              </VaSidebarItemTitle>
            </VaSidebarItemContent>
          </VaSidebarItem>
        </template>
      </VaCollapse>
    </VaAccordion>
  </VaSidebar>
</template>

<script setup lang="ts">
import { watch, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useColors } from 'vuestic-ui'
import { useGlobalStore } from '../../stores/global-store'

const { getColor, colorToRgba } = useColors()
const route = useRoute()

const value = ref<boolean[]>([])

const GlobalStore = useGlobalStore()
const { isMobile } = storeToRefs(GlobalStore)

interface NavigationRoute {
  name: string
  path: string
  icon: string
}

const mainRoutes: NavigationRoute[] = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: 'vuestic-iconset-dashboard'
  },
  {
    name: 'Users',
    path: '/users',
    icon: 'group'
  },
  {
    name: 'Products',
    path: '/products',
    icon: 'shopping_bag'
  },
  {
    name: 'PromoCodes',
    path: '/promocodes',
    icon: 'discount'
  },
  {
    name: 'Shipping Fee',
    path: '/shipping-fee',
    icon: 'local_shipping'
  },
  {
    name: 'Orders',
    path: '/orders',
    icon: 'mso-payments'
  },
  {
    name: 'Certificate of Analysis',
    path: '/coas',
    icon: 'verified'
  },
  {
    name: 'Settings',
    path: '/settings',
    icon: 'settings'
  },
]

const routeHasActiveChild = (section: NavigationRoute) => {
  return route.path === section.path || route.path.startsWith(section.path)
}

const setActiveExpand = () => (value.value = mainRoutes.map((route: NavigationRoute) => routeHasActiveChild(route)))

const color = computed(() => getColor('background-secondary'))
const activeColor = computed(() => colorToRgba(getColor('focus'), 0.1))
const iconColor = (route: NavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'secondary')
const textColor = (route: NavigationRoute) => (routeHasActiveChild(route) ? 'primary' : 'textPrimary')

watch(() => route.fullPath, setActiveExpand, { immediate: true })
</script>
